import type { Operator } from "./index.js"

// Both bounds must be non-null — a partial range (one bound set) matches nothing
// because its intent is ambiguous.

export const between: Operator = {
  key: "between",
  label: "is between",
  icon: "arrows-left-right",
  value: "range",
  fn: (a, b) => {
    if (!Array.isArray(b) || b.length !== 2 || b[0] == null || b[1] == null) return false
    const av = a as number | string
    return av >= b[0] && av <= b[1]
  },
}

export const notBetween: Operator = {
  key: "notBetween",
  label: "is not between",
  icon: "arrows-left-right",
  value: "range",
  fn: (a, b) => {
    if (!Array.isArray(b) || b.length !== 2 || b[0] == null || b[1] == null) return false
    // Null-excluding, matching `col NOT BETWEEN ...` (NULL in → NULL out → row
    // dropped). See the note on notEquals in equality.ts. `null < 1` coerces to
    // 0 in JS, so without this guard a null compares as below every lower
    // bound and is reported as "not between" — the opposite of what runs.
    if (a == null) return false
    const av = a as number | string
    return av < b[0] || av > b[1]
  },
}
